import React from 'react';
import { Paper, Box, Typography, Button } from '@mui/material';
import { ElectricBolt, RestartAlt } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

function PowerCostEmptyState({ onResetFilters }) {
    const { t } = useTranslation();

    return (
        <Paper
            elevation={1}
            sx={{
                p: { xs: 4, sm: 6 },
                textAlign: 'center',
                borderRadius: 2,
                bgcolor: 'background.paper',
                border: '1px dashed',
                borderColor: 'divider',
                my: 4,
            }}
        >
            <Box
                sx={{
                    width: 72,
                    height: 72,
                    borderRadius: '50%',
                    bgcolor: 'rgba(16, 185, 129, 0.12)',
                    color: '#10b981',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    mx: 'auto',
                    mb: 2,
                }}
            >
                <ElectricBolt sx={{ fontSize: 38 }} />
            </Box>

            <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
                {t('common.noPowerCostData', 'No electricity cost data available')}
            </Typography>

            <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 480, mx: 'auto', mb: 3 }}>
                {t(
                    'common.noPowerCostHint',
                    'Try changing the billing year, month, or reading day to recalculate estimated electricity costs.'
                )}
            </Typography>

            {onResetFilters && (
                <Button
                    variant="contained"
                    startIcon={<RestartAlt />}
                    onClick={onResetFilters}
                    sx={{ textTransform: 'none', borderRadius: 2 }}
                >
                    {t('common.resetFilters', 'Reset Filters')}
                </Button>
            )}
        </Paper>
    );
}

export default PowerCostEmptyState;
